package com.ervasstudio.tracoemovimento.pages.home

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px

@Composable
fun HeroLine(text: String, isMobile: Boolean, marginTop: CSSSizeValue<CSSUnit.px> = 0.px) {
    Box(
        modifier = Modifier
            .padding(leftRight = if (isMobile) 4.px else 10.px)
            .margin(top = marginTop)
    ) {
        SpanText(
            modifier = Modifier
                .fontSize(if (isMobile) 2.3.cssRem else 10.cssRem)   // era 10.cssRem
                .fontFamily("Gotham")
                .fontWeight(FontWeight.Bold)
                .overflow(Overflow.Hidden)
                .lineHeight(1)
                .color(Colors.Black)
                .styleModifier {
                    property("-webkit-text-stroke", if (isMobile) "1px white" else "2px white")
                    property("paint-order", "stroke fill")
                },
            text = text
        )
    }
}